import React from 'react'

function TextArea({ ...rest }) {
    return (
        <textarea
            {...rest}
            rows={6}
            className="w-full border rounded-2xl mt-5 
    outline-none p-3 text-sm focus:border-black"
        />
    )
}

export default TextArea